import http from '@/plugins/api'
import * as types from './types'
import { startLoading } from '@/plugins/loading'

const authUrl = window.config ? window.config.authUrl : ''

export default {
  clearToken({ commit, state }) {
    commit(types.RESET_LOGIN)
  },
  setPassthrough({ commit }, passthrough) {
    commit(types.SET_PASSTHROUGH, passthrough)
  },
  async getToken({ commit, getters, dispatch }, [user, pwd]) {
    const t = await startLoading(dispatch, 'getToken', () =>
      http.post('getToken', { username: user, password: pwd }, {}, authUrl)
    )
    commit(types.SET_TOKEN, t.data)
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/auth/actions.js